import StorageList from '../../storages/StorageList'

export const OpenStorage = () => {
  return (
    <StorageList />
  )
}

